var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('leftmenu'),_c('topmenu'),_c('v-content',{attrs:{"fill-height":"","id":"base-content"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }